import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

import { AnalyticsStrings, CIPPrediction } from "constants/constantStrings";
import { SYSTEMS_PAGES } from "constants/pages.constant";

import { getCleaningRequiredTableColDef } from "pages/Analytics/AnalyticsCleaningRequiredTable/CIPCleaningRequiredTable.config";
import AgTable from "components/AgTable";
import TextWithRightArrow from "components/TextWithRightArrow";

import TrendingUp from "assets/SvgIcon/TrendingUp";

import "../index.scss";

const CipCleaningCard = ({ value, customClass }) => {
  const { tagsAsObj } = useSelector(state => state.tags);
  const [cleaningTableData, setCleaningTableData] = useState([]);
  const [cleaningColDef, setCleaningColDef] = useState(getCleaningRequiredTableColDef(false));

  useEffect(() => {
    try {
      const formattedData =
        value?.Normalized_Tag_Exceptions?.map(item => {
          const { TagName, Units } = tagsAsObj[item.Tag];
          return { ...item, TagName: `${TagName} (${Units})` };
        }) || [];
      setCleaningTableData(formattedData);
    } catch (err) {}
  }, []);

  return (
    <div className={`insight-card ${customClass} `}>
      <div className="flex-between marginBtm10 ">
        <div className="fullWidth">
          <div className="d-flex mb-15">
            <h1>{AnalyticsStrings.CIP_Cleaning_Required}</h1>
          </div>
          <div className="table-Container">
            <AgTable rowData={cleaningTableData} columnDefs={cleaningColDef} rowHeight={50} customTableClass="ag-theme-readOnly-react" />
          </div>

          <div className="margin-top-10 inspect-text width_fit-content">
            <NavLink to={`../${SYSTEMS_PAGES.ANALYTICS}`}>
              <TrendingUp />
              <TextWithRightArrow text={CIPPrediction.inspectfurther} fontStyle={"clickable-green-text"} />
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CipCleaningCard;
